import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import socketService from '../services/socketService';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      try {
        const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
        const userId = userData.almataPartner?.id;
        
        if (userId) {
          socketService.startUserValidation(userId, "almatapartner");
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }

    return () => {
      socketService.stopValidation();
    };
  }, [isAuthenticated]);

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;